import career from "@partials/partner-career.handlebars";
import axios from "@main/axios";
import {logger} from "@main/helpers/logger";
import {ToggleScroll} from "@main/components/toggle-scroll";

/** Класс открытия модального окна на странице карьеры */
export class OpenCareerModal {
    modal = document.querySelector(".js-modal-career");
    modalCareerBlock = this.modal.querySelector(".js-vacancy");
    /**
     * Конструктор класса.
     *
     * @param {HTMLLinkElement} link Элемент.
     */
    constructor(link) {
        this.link = link;
        this.url = this.link.dataset.url;
        this.bindEventListeners();
    }

    /**
     * Отслеживаем событие клика.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        this.link.addEventListener("click", (e) => {
            if (e.target.tagName === "A") {
                return;
            }
            if (e.target.classList.contains("js-open-career-modal") || e.target.closest(".js-open-career-modal")) {
                const button = e.target.classList.contains("js-open-career-modal") 
                    ? e.target 
                    : e.target.closest(".js-open-career-modal");
                const careerCard = button.closest(".js-open-career-modal");
                this.careerId = careerCard.dataset.idCareer;
                this.updateModalContent(this.careerId);
            }
        });

        document.addEventListener("click", (e) => {
            if (e.target.classList.contains("js-overlay") || e.target.classList.contains("js-modal-close")) {
                this.modalCareerBlock.innerHTML = "";
            }
        });

    }

    /**
     * Получение описания возможности центра.
     *
     * @param {string} id Получение id выбранной возможности.
     * @returns {Promise}
     */
    getCareerDescription = async (id) => {
        try {
            const {data} = await axios({
                url: this.url,
                method: "GET",
                params: {
                    id,
                }
            });

            return data;
        } catch (e) {
            logger.log(e);
        }
    }

    /**
     * Открытие модального окна.
     * 
     * @returns {void}
     */
    openModal() {
        this.modal.classList.add("shown");
        ToggleScroll.disable(this.modal);
    }

    /**
     * Обновление контента модального окна.
     *
     * @returns {void}
     */
    updateModalContent = async (id) => {
        const response = await this.getCareerDescription(id);
        const data = response.data;
        const cardCareer = {
            career: {
                id: data.id,
                name: data.name,
                text: data.text,
                phone: data.phone,
                mail: data.mail,
                link: data.link,
                btnLink: data.btnLink,
                btnName: data.btnName,
                subtitle: data.subtitle,
                listPopup: data.listPopup,
            }
        };
        const careerDescription = career(cardCareer);

        this.modalCareerBlock.innerHTML = "";
        this.modalCareerBlock.insertAdjacentHTML("beforeend", careerDescription);
        this.openModal();
    }
}

document.querySelectorAll(".js-open-career-modal").forEach((el) => new OpenCareerModal(el));
